import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../../shared/error-boundary';
import relativeTime from '../../shared/relative-time';

export default function RelativeTime(props) {
  const time = relativeTime(props.timestamp, props.useShortVersion) || 'Not Published';

  return (
    <>
      <ErrorBoundary>
        {
          props.wireUrl
            ? <a href={props.wireUrl}>{time}</a>
            : <span>{time}</span>
        }
      </ErrorBoundary>
    </>
  );
}

RelativeTime.propTypes = {
  timestamp: PropTypes.string,
  wireUrl: PropTypes.string,
  useShortVersion: PropTypes.bool,
};

RelativeTime.defaultProps = {
  timestamp: null,
  wireUrl: null,
  useShortVersion: false,
};
